import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Draggable } from '@hello-pangea/dnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowRightLong, faArrowLeftLong, faArrowDownLong, faArrowUpLong, faArrowDown19,
    faArrowUp19
} from '@fortawesome/free-solid-svg-icons';
import { LuArrowDownUp } from "react-icons/lu";

import moment from 'moment';
import { TaskContext } from './../context';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import ConfirmationPopup from './ConfirmationPopup';
import TaskData from './Task/TaskData';
import { useNavigate } from 'react-router-dom';
import CONSTANTS from '../CONSTANTS.json';
import services from '../services';
import ChildTask from './ChildTask';
import TaskDropdownModal from './TaskDropdownModal';
import { HiMailOpen } from 'react-icons/hi';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { LiaTagsSolid } from 'react-icons/lia';
import { FaLink } from 'react-icons/fa';
import { GoGitCompare } from 'react-icons/go';
import LabelIcon from "@mui/icons-material/Label";
import { Tooltip } from "react-tooltip";
import {
    setSelectedMyDayPlanDate,
    setSelectedReminderDate,
    setSelectedStatusNextStepDate,
    setNote,
    setNotesText,
    setMyDayDate,
    setDeadlineDate,
    setIsMyDayChecked,
    setIsDeadlineChecked,
} from '../Redux/slice';

const today = new Date();

const allDaysData = [
    {
        deadline: 'Today',
        dayName: CONSTANTS.daysOfWeek[today.getDay()],
    },
    {
        deadline: 'Tomorrow',
        dayName: CONSTANTS.daysOfWeek[(today.getDay() + 1) % 7],
    },
    {
        deadline: 'In two days',
        dayName: CONSTANTS.daysOfWeek[(today.getDay() + 2) % 7],
    },
    {
        deadline: 'Next week',
        dayName: CONSTANTS.daysOfWeek[(today.getDay() + 5) % 7],
    },
    {
        deadline: 'Pick a date',
        dayName: '',
    },
    {
        deadline: 'Add this item to My Day plan',
        dayName: '',
    },
];

export const useTaskData = () => {
    const dispatch = useDispatch();
    const {
        selectedMyDayPlanDate,
        selectedReminderDate,
        selectedStatusNextStepDate,
        note,
        notesText,
        myDayDate,
        deadlineDate,
        isMyDayChecked,
        isDeadlineChecked,
    } = useSelector((state) => state.redux);

    return {
        selectedMyDayPlanDate,
        setSelectedMyDayPlanDate: (v) => dispatch(setSelectedMyDayPlanDate(v)),
        selectedReminderDate,
        setSelectedReminderDate: (v) => dispatch(setSelectedReminderDate(v)),
        selectedStatusNextStepDate,
        setSelectedStatusNextStepDate: (v) => dispatch(setSelectedStatusNextStepDate(v)),
        note,
        setNote: (v) => dispatch(setNote(v)),
        notesText,
        setNotesText: (v) => dispatch(setNotesText(v)),
        myDayDate,
        setMyDayDate: (v) => dispatch(setMyDayDate(v)),
        deadlineDate,
        setDeadlineDate: (v) => dispatch(setDeadlineDate(v)),
        isMyDayChecked,
        setIsMyDayChecked: (v) => dispatch(setIsMyDayChecked(v)),
        isDeadlineChecked,
        setIsDeadlineChecked: (v) => dispatch(setIsDeadlineChecked(v)),
    };
};

function Task(props) {
    const { updateDeadlineDateInLocalStorage, moduleName } = React.useContext(TaskContext);




    const curretnTaskdata = useSelector((state) => state.redux.currentTask);
    const {
        item,
        moveTaskToColumn,
        indexId,
        removeTask,
        moveTaskDown,
        moveTaskUp,
        getTaskMail,
        columnTitle,
        setTaskDetailsPopup,
        taskDeadline,
        userAssigneeName,
        taskColor,
        taskAssign,
        setSearchTerm,
        searchTerm,
        isShiftPressed,
        moveChildTask,
        columnID,
        handleRemoveChild,
        setIsShiftPressed,
        getTaskMailIndbox,
        handleUpdateTask,
        handleSingleClick,
        handleTaskDetailPopup,
        showModal,
        taskDetailsModal,
        setTaskDetailModal,
        currentTask,
        setCurrentTask,
        editTaskTitle,
        setEditTaskTitle,
        selectedTaskcolor,
        setSelectedTaskcolor,
        isOpen,
        setIsOpen,
        taskDeleteId,
        toggleTaskDropdown,
        showBox,
        setShowBox,
        setIsSearchBoxOpen,
        setHoverIndex,
        setColorIndexID,
        setActivePatch,
        hoverIndex,
        colorIndexID,
        activePatch,
        handleEditTitle,
        clearHighlight,
        handleClick,
        setUpdateTitle,
        updateTitle,
        setIsOpenDeadline,
        isOpenDeadline,
        isSearchBoxOpen,
        deleteTask,
        taskToDelete,
        setTaskToDelete,
        handleCancelDelete,
        clickTimeoutRef,
        ignoreNextClickRef,
        selectedBoardId,
        allTaskData,
        moveTask,
        hoveredIndex,
        setHoveredIndex,
        moveTaskToIndex,
        updateStatusTask,
        createTaskMail,
        setStatusUpdate,
        moveTaskInState,
        moveTaskToOtherColumnInState,
        allCustomFieldList,
        isMember,
        parentOrigin
    } = props;




    const [selectedDate, setSelectedDate] = useState(new Date());
    const [isProgress, setIsProgress] = useState(false);
    const [deadline, setDeadline] = useState('');
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const [showTime, setShowTime] = useState(false);
    const [taskitemasign, setTaskitemasign] = useState('');
    const [weedDays, setWeekDays] = useState(false);
    const [checked, setChecked] = React.useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [assignedUserName, setAssignedUserName] = useState('');
    const [userName, setUserName] = useState('');
    const [editingTaskId, setEditingTaskId] = useState(null);
    const [openDeadlineTaskId, setOpenDeadlineTaskId] = useState(null);
    let clickTimeout = null;
    const popupRef = useRef(null);
    const [searchBoxTaskId, setSearchBoxTaskId] = useState(null);
    const [taskTitle, setTaskTitle] = useState('');
    const [openUpwards, setOpenUpwards] = useState(false);
    const dropdownRef = useRef();
    const [searchOpenUpwards, setSearchOpenUpwards] = useState(false);
    const searchDropdownRef = useRef();
    const [deadlineOpenUpwards, setDeadlineOpenUpwards] = useState(false);
    const deadlineDropdownRef = useRef();
    const ref = useRef(null);
    const [isHovered, setIsHovered] = useState(false);

    const [isDependencyModalOpen, setIsDependencyModalOpen] = useState(false);
    const [taskForDependency, setTaskForDependency] = useState(null);
    const [dependencySearchTerm, setDependencySearchTerm] = useState('');
    const [initialDependencies, setInitialDependencies] = useState([]);
    const [selectedDependencies, setSelectedDependencies] = useState(new Set());
    const [allDependencies, setAllDependencies] = useState([]);
    const [isDependenciesModalOpen, setIsDependenciesModalOpen] = useState(false);
    const [taskWithDependencies, setTaskWithDependencies] = useState(null);
    const [dependenciesList, setDependenciesList] = useState([]);

    const allTasksForDep = Object.values(allTaskData)
        .flat()
        .filter((task) => task.boardId === selectedBoardId);

    const fetchAllDependencies = async () => {
        try {
            const response = await services.task.GET_ALL_DEPENDENCIES();
            setAllDependencies(response.data.data);
        } catch (error) {
            console.error('Failed to fetch dependencies', error);
            toast.error('Could not load dependency information.');
        }
    };

    useEffect(() => {

    }, []);

    const openDependencyModal = (item) => {
        const currentDeps = allDependencies
            .filter((dep) => dep.dependerId === item.id)
            .map((dep) => ({
                dependencyId: dep.dependencyId,
                linkId: dep.id,
            }));
        setTaskForDependency(item);
        setInitialDependencies(currentDeps);
        setSelectedDependencies(new Set(currentDeps.map((d) => d.dependencyId)));
        setIsDependencyModalOpen(true);
    };

    const closeDependencyModal = () => {
        setIsDependencyModalOpen(false);
        setTaskForDependency(null);
        setDependencySearchTerm('');
        setInitialDependencies([]);
        setSelectedDependencies(new Set());
    };

    const toggleDependency = (taskId) => {
        setSelectedDependencies((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(taskId)) {
                newSet.delete(taskId);
            } else {
                newSet.add(taskId);
            }
            return newSet;
        });
    };

    const handleSaveDependencies = async () => {
        if (!taskForDependency) return;

        const initialDepIds = new Set(initialDependencies.map((d) => d.dependencyId));
        const finalDepIds = selectedDependencies;

        const toAdd = [...finalDepIds].filter((id) => !initialDepIds.has(id));
        const toRemove = initialDependencies.filter((d) => !finalDepIds.has(d.dependencyId));

        const creationPromises = toAdd.map((dependencyId) =>
            services.task.CREATE_DEPENDENCY({
                dependerId: taskForDependency.id,
                dependencyId: dependencyId,
                type: 'blocks',
            }),
        );

        const deletionPromises = toRemove.map((dep) => services.task.DELETE_DEPENDENCY(dep.linkId));

        try {
            await Promise.all([...creationPromises, ...deletionPromises]);
            toast.success('Dependencies updated successfully!');
            fetchAllDependencies();
            getTaskMail(1, '', selectedBoardId);
        } catch (error) {
            console.error('Failed to update dependencies', error);
            toast.error('Failed to update dependencies.');
        } finally {
            closeDependencyModal();
        }
    };

    const filteredTasksForDep = allTasksForDep.filter(
        (t) =>
            t.id !== (taskForDependency && taskForDependency.id) &&
            (t.title || t.subject || '').toLowerCase().includes(dependencySearchTerm.toLowerCase()),
    );

    useEffect(() => {
        if (isOpen && dropdownRef.current) {
            const rect = dropdownRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            if (spaceBelow < 250) {
                setOpenUpwards(true);
            } else {
                setOpenUpwards(false);
            }
        }
    }, [isOpen]);

    useEffect(() => {
        if (openDeadlineTaskId && deadlineDropdownRef.current) {
            setTimeout(() => {
                const rect = deadlineDropdownRef.current.getBoundingClientRect();
                const spaceBelow = window.innerHeight - rect.bottom;
                if (spaceBelow < 250) {
                    setDeadlineOpenUpwards(true);
                } else {
                    setDeadlineOpenUpwards(false);
                }
            }, 0);
        }
    }, [openDeadlineTaskId]);
    useEffect(() => {
        if (searchBoxTaskId && searchDropdownRef.current) {
            const rect = searchDropdownRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            if (spaceBelow < 250) {
                setSearchOpenUpwards(true);
            } else {
                setSearchOpenUpwards(false);
            }
        }
    }, [searchBoxTaskId]);

    const handleChange = () => {
        setChecked(!checked);
    };

    const navigate = useNavigate();

    const itemId = item?.id;

    const updateTaskMail = async (id, dedlineData) => {
        const msgId = item?.gmailMessageId;
        const data = {
            deadline: dedlineData,
            taskStatus: columnTitle,
            title: editTaskTitle,
            gmailMessageId: msgId,
        };

        try {
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${id}`, data);
            if (response) {
                setUpdateTitle(false);
                getTaskMail(1, '', selectedBoardId);
                setEditingTaskId(null);
                setEditTaskTitle('');
                setTaskTitle('');
            }
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate('/login');
            }
        }
    };

    const handleDoubleClick = (item, e) => {
        if (clickTimeoutRef.current) {
            clearTimeout(clickTimeoutRef.current);
            clickTimeoutRef.current = null;
        }

        ignoreNextClickRef.current = true;
        if (item?.id) {
            setEditingTaskId(item.id);
            setEditTaskTitle(item?.title || item?.subject);
            setTaskTitle(item?.title || item?.subject);
        } else {
            setEditingTaskId(null);
            setEditTaskTitle('');
            setTaskTitle('');
        }
        setCurrentTask(false);
    };

    const selectedColor = CONSTANTS?.color?.find((color) => color.value === taskColor);
    const borderColor = selectedColor ? selectedColor.value1 : '0px';

    const deleteTaskMail = async () => {
        try {
            const response = await services.task.DELETE_TASK(taskDeleteId);
            if (response) {
                getTaskMail();
                setShowBox(false);
            }
        } catch (error) {
            console.error('Error fetching task emails:', error);
        }
    };

    const filteredUsers = taskAssign.filter((user) => user.name.toLowerCase());
    const textareaRef = useRef(null);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            updateTaskMail(item?.id);
        }
    };
    useEffect(() => {
        function handleClickOutside(e) {
            if (
                textareaRef.current &&
                !textareaRef.current.contains(e.target)
            ) {
                updateTaskMail(item?.id);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [updateTaskMail, item]);




    const handleDateChange = (date) => {
        updateDeadlineDateInLocalStorage(itemId, date);
        setSelectedDate(date);
        setIsCalendarOpen(false);
        setIsOpenDeadline(!isOpenDeadline);
    };

    const deadlineDrop = (id) => {
        setShowTime(!showTime);
        setIsOpenDeadline(!isOpenDeadline);
        setOpenDeadlineTaskId(openDeadlineTaskId === id ? null : id);
    };

    const inTaskProgress = () => {
        setIsProgress(!isProgress);
    };

    const handleDeadlineChange = (e) => {
        setDeadline(e.target.value);
    };

    const handleToggleSearchBox = (itemData) => {
        setTaskitemasign(itemData?.id);
        setSearchBoxTaskId((prev) => (prev === itemData?.id ? null : itemData?.id));
    };

    const handleTodayClick = () => {
        setShowTime(true);
        setWeekDays(true);
        const today = new Date();
        const dedlineData = today.toISOString();
        setDeadline(dedlineData);
        setIsOpenDeadline(false);
        updateTaskMail(item?.id, dedlineData);
    };

    const handleTomorrowClick = () => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        setShowTime(true);
        setWeekDays(true);
        setIsOpenDeadline(false);
        const dedlineData = tomorrow.toISOString();
        setDeadline(dedlineData);
        updateTaskMail(item?.id, dedlineData);
    };

    const handleNextTwoDaysClick = () => {
        const nextTwoDays = new Date();
        nextTwoDays.setDate(nextTwoDays.getDate() + 2);
        setShowTime(true);
        setWeekDays(true);
        setIsOpenDeadline(false);
        const dedlineData = nextTwoDays.toISOString();
        setDeadline(dedlineData);
        updateTaskMail(item?.id, dedlineData);
    };

    const handleNextWeekDaysClick = () => {
        const nextWeek = new Date();
        nextWeek.setDate(nextWeek.getDate() + 4);
        setShowTime(true);
        setWeekDays(true);
        setIsOpenDeadline(false);
        const dedlineData = nextWeek.toISOString();
        setDeadline(dedlineData);
        updateTaskMail(item?.id, dedlineData);
    };

    const handleEditTitleNew = (item) => {
        setEditingTaskId(item.id);
        setEditTaskTitle(item?.title || item?.subject);
        setUpdateTitle(true);
        setIsOpen(!isOpen);
        setIsOpenDeadline(false);
    };

    const handleInputBlur = () => {
        setEditingTaskId(null);
        setCurrentTask(false);
    };

    const handleTaskSelectedColor = async (selectedColor) => {
        const data = {
            color: selectedColor,
        };
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${selectedTaskcolor}`,
                data,
            );
            getTaskMail(1, '', selectedBoardId);
            setSearchBoxTaskId(null);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleUserSelect = async (user) => {
        const data = {
            userId: user,
        };
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${taskitemasign}`,
                data,
            );
            if (response && selectedBoardId) {
                getTaskMail(1, '', selectedBoardId);

            }
            setSearchBoxTaskId(null);
        } catch (error) {
            console.error('err');
        }
    };

    const handleEditTitleSave = () => {
        if (editTaskTitle !== (item?.title || item?.subject)) {
            updateTaskMail(editingTaskId, editTaskTitle);
        }
        setEditingTaskId(null);
        setCurrentTask(false);
    };

    useEffect(() => {
        if (taskColor) {
            setActivePatch(taskColor);
        }
    }, [taskColor]);

    useEffect(() => {
        if (userAssigneeName && taskAssign) {
            const user = taskAssign.find((u) => u.id === userAssigneeName);
            if (user) {
                setUserName(user.name);
            }
        }
    }, [userAssigneeName, taskAssign]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (deadlineDropdownRef.current && !deadlineDropdownRef.current.contains(event.target)) {
                setOpenDeadlineTaskId(null);
                setIsOpenDeadline(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey || e.shiftKey) {
                setIsShiftPressed(true);
            }
        };
        const handleKeyUp = (e) => {
            if (!e.ctrlKey && !e.shiftKey) {
                setIsShiftPressed(false);
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, [setIsShiftPressed]);

    useEffect(() => {
        if (item?.deadline) {
            setDeadline(moment(item?.deadline).format('MMM D'));
        }
    }, [item]);

    useEffect(() => {
        if (indexId === 3) {
        }
    }, [item, indexId, taskColor, userAssigneeName]);

    const setIsSearchBoxClose = () => {
        setSearchBoxTaskId(null);
    };

    const handleCreateTask = async (dragItem, item) => {
        try {
            const { data } = await services.task.CREATE_TASK({ gmailMessageId: dragItem?.item?.gmailMessageId });
            await moveChildTask({ item: { id: data?.data?.id } }, item);
            getTaskMailIndbox();
        } catch (e) {
            console.error(e);
        }
    };

    const updateStatusTaskMessage = async (gmailMessageId, status) => {
        const data = {
            messageRead: status,
        };
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/email/updatedMessageRead/${gmailMessageId}`,
                data,
            );
            if (response && selectedBoardId) {
                await getTaskMail(1, '', selectedBoardId);
            }
        } catch (error) {
            console.error('Error updating task status:', error);
        }
    };

    const [showArchiveConfirmation, setShowArchiveConfirmation] = useState(false);
    const [taskToArchiveAction, setTaskToArchiveAction] = useState(null);

    const archiveTask = async (item) => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${item?.id}`, {
                isInComplete: true,
            });

            if (response) {
                toast.success('Task archived successfully');
                getTaskMail(1, '', selectedBoardId);
            }
        } catch (error) {
            console.error('Error archiving task:', error);
            if (error.response && error.response.data && error.response.data.message) {
                let taskNames = error.response.data.error.replace(/^Error updating Task:\s*/, "");


                toast.error(taskNames);
            } else {
                toast.error('Failed to archive task');
            }
        }
    };
    const handleArchiveClick = (item) => {
        const itemDependencies = allDependencies.filter((dep) => dep.dependerId === item.id).map((d) => d.dependencyId);

        if (itemDependencies.length > 0) {
            const allTasks = Object.values(allTaskData).flat();
            const incompleteDependencies = itemDependencies.filter((depId) => {
                const dependentTask = allTasks.find((t) => t.id === depId);
                return dependentTask && !dependentTask.isInComplete;

            });

            if (incompleteDependencies.length > 0) {
                const incompleteTaskNames = incompleteDependencies
                    .map((depId) => {
                        const dependentTask = allTasks.find((t) => t.id === depId);
                        return dependentTask ? dependentTask.title || dependentTask.subject : 'an unknown task';
                    })
                    .join(', ');
                toast.error(`Please complete the following dependent tasks first: ${incompleteTaskNames}`);
                return;
            }
        }









        setShowArchiveConfirmation(true);
        setTaskToArchiveAction(item);
    };

    const handleConfirmArchive = () => {
        if (taskToArchiveAction) {
            archiveTask(taskToArchiveAction);
        }
        setShowArchiveConfirmation(false);
        setTaskToArchiveAction(null);
    };

    const handleCancelArchive = () => {
        setShowArchiveConfirmation(false);
        setTaskToArchiveAction(null);
    };
    const sla_alert_action = [
        {
            label: '🔥SLA Due',
            value: 'SLA Due',
            color: 'border border-pink-500 text-pink-600 text-[10px] bg-pink-100',
        },
        {
            label: '⚡SLA Soon',
            value: 'SLA Soon',
            color: 'border border-orange-500 text-orange-600 text-[10px] bg-orange-100',
        },
    ];

    const collectUniqueSlaTags = (item) => {
        const parentTags = item?.addProperty?.slaTags || [];

        const subTaskTags = (item?.SubTasks || []).flatMap((sub) => sub?.addProperty?.slaTags || []);

        const combinedTags = [...parentTags, ...subTaskTags];

        return [...new Set(combinedTags)];
    };



    const hasDependencies = allDependencies.some((dep) => {
        return dep.dependerId === item.id;
    });


    const openDependenciesModal = async (item) => {
        try {
            const response = await services.task.GET_TASK_DEPENDENCIES(item.id);



            const dependentTasks = response.data.data.map((dep) => dep.Dependency);

            setTaskWithDependencies(item);
            setDependenciesList(dependentTasks || []);
            setIsDependenciesModalOpen(true);
        } catch (error) {
            console.error('Failed to fetch dependencies for task', item.id, error);
            toast.error('Could not load dependency information for this task.');
        }
    };

    const closeDependenciesModal = () => {
        setIsDependenciesModalOpen(false);
        setTaskWithDependencies(null);
        setDependenciesList([]);
    };
    const extractEmail = (value, { html = false } = {}) => {
        if (!value) return "";

        const parts = value.split(",").map(v => v.trim()).filter(Boolean);

        const emails = parts.map(part => {
            const match = part.match(/<([^>]+)>/);
            if (match) return match[1];
            if (part.includes("@")) return part;
            return "";
        }).filter(Boolean);

        if (html) {
            return emails.map(e => `<div style="white-space:nowrap;">${e}</div>`).join("");
        }

        return emails.join(", ");
    };




    return (
        <>
            <Draggable draggableId={String(item.id)} index={indexId}>
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className={`task-crat ${(item?.subEmail?.messageRead === 'unread' ||
                            item?.Email?.messageRead === 'unread')
                            ? 'task-crat-blink'
                            : ''
                            }`}
                        style={{
                            ...provided.draggableProps.style,
                            opacity: snapshot.isDragging ? 0.5 : 1,
                            backgroundColor: item?.color,
                            borderLeft: `5px solid ${borderColor === '0px' ? 'transparent' : borderColor}`,
                            cursor: 'auto',
                        }}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        onClick={() =>
                            updateStatusTaskMessage(item?.Email?.gmailMessageId || item?.subEmail?.gmailMessageId, 'read')
                        }
                    >
                        <div
                            onClick={(e) => {
                                handleSingleClick(item, e, false);
                            }}
                        >
                            <div className="" onMouseDown={(e) => e.stopPropagation()}>
                                {isCalendarOpen && (
                                    <div className="pick-A-calendar">
                                        <DatePicker selected={selectedDate} onChange={handleDateChange} inline />
                                    </div>
                                )}
                                <div className="">
                                    <>
                                        <div className="">
                                            <div className="flex">
                                                {moduleName === 'board' ? (
                                                    <></>
                                                ) : moduleName === 'datePaln' ? (
                                                    <>{item?.deadline ? moment(item.deadline).format('MMM DD') : ''}</>
                                                ) : (
                                                    <></>
                                                )}
                                            </div>

                                            <div
                                                className="grid-disp "
                                                style={{ alignItems: 'flex-start' }}
                                                onClick={() =>
                                                    updateStatusTaskMessage(
                                                        item?.Email?.gmailMessageId || item?.subEmail?.gmailMessageId,
                                                        'read',
                                                    )
                                                }
                                            >
                                                {editingTaskId !== item.id ? (
                                                    <>
                                                        <h3
                                                            className="title-box"
                                                            onDoubleClick={(e) => {
                                                                handleDoubleClick(item, e);
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    flexWrap: 'wrap',
                                                                    alignItems: 'start',
                                                                }}
                                                            >
                                                                <div className="flex flex-col gap-1 mt-2">
                                                                    <div className="flex gap-1">
                                                                        {allCustomFieldList
                                                                            ?.filter((field) => {
                                                                                const matchBoard =
                                                                                    field?.customPropertyId &&
                                                                                    field?.CustomProperty?.boardId === selectedBoardId;

                                                                                const selectedFieldIds =
                                                                                    item?.customProperty?.flatMap((cp) => cp?.selectedFieldId || []);
                                                                                const matchFieldId = selectedFieldIds?.includes(field?.id);

                                                                                const isVisible = field?.CustomProperty?.isVisible === true;

                                                                                // Only show Status fields
                                                                                return (
                                                                                    matchBoard &&
                                                                                    matchFieldId &&
                                                                                    isVisible &&
                                                                                    field.customField?.name === 'Status' &&
                                                                                    (typeof field.customField?.value === 'string' ||
                                                                                        typeof field.customField?.value === 'number') // <-- Only render if string/number
                                                                                );
                                                                            })
                                                                            ?.map((field) => (
                                                                                <span
                                                                                    key={field.id}
                                                                                    className="px-2 py-0.5 rounded bg-gray-200 text-sm mt-1"
                                                                                    style={{
                                                                                        color: 'white',
                                                                                        background: field?.customField?.color || '#ccc',
                                                                                        borderRadius: '999px',
                                                                                    }}
                                                                                >
                                                                                    {field.customField?.value || 'No Status'}
                                                                                </span>
                                                                            ))}
                                                                    </div>

                                                                    <div className="flex flex-wrap gap-1 ">
                                                                        {allCustomFieldList
                                                                            ?.filter((field) => {
                                                                                const matchBoard =
                                                                                    field?.customPropertyId &&
                                                                                    field?.CustomProperty?.boardId === selectedBoardId;

                                                                                const selectedFieldIds =
                                                                                    item?.customProperty?.flatMap((cp) => cp?.selectedFieldId || []);

                                                                                const matchFieldId = selectedFieldIds?.includes(field?.id);

                                                                                const isVisible = field?.CustomProperty?.isVisible === true;

                                                                                // Only show Tag fields
                                                                                return (
                                                                                    matchBoard &&
                                                                                    matchFieldId &&
                                                                                    isVisible &&
                                                                                    field.customField?.name === 'Tag' &&
                                                                                    Array.isArray(field.customField?.value) && // <-- ensure value is array
                                                                                    field.customField.value.every(
                                                                                        (tag) => tag && typeof tag.label === 'string'
                                                                                    ) // <-- ensure each item has a label
                                                                                );
                                                                            })
                                                                            ?.flatMap((field) =>
                                                                                field.customField.value.map((tag, i) => (
                                                                                    <span
                                                                                        key={`${field.id}-${i}`}
                                                                                        className="px-2 py-0.5 rounded text-sm mb-2"
                                                                                        style={{
                                                                                            color: tag.color || '#2196f3',
                                                                                            border: `1px solid ${tag.color || '#2196f3'}`,
                                                                                            borderRadius: '999px',
                                                                                        }}
                                                                                    >
                                                                                        #{tag.label}
                                                                                    </span>
                                                                                ))
                                                                            )}
                                                                    </div>

                                                                </div>
                                                                <div className="text-[12px] text-gray-500 flex gap-2 items-center">
                                                                    {item?.taskType === "Gmail" && item?.Email && (
                                                                        <>
                                                                            {/* FROM */}
                                                                            <LuArrowDownUp
                                                                                data-tooltip-id="my-tooltip"
                                                                                data-tooltip-html={`
                                                                                <div style="display:grid; grid-template-columns:70px auto; row-gap:6px;">
                                                                                <div><strong>From</strong></div>
                                                                                <div>${extractEmail(item?.Email?.sentBy || item?.sentBy, { html: true })}</div>

                                                                                <div><strong>To</strong></div>
                                                                                <div>${extractEmail(item?.Email?.sentTo || item?.sentTo, { html: true })}</div>
                                                                                </div>
                                                                            `}
                                                                                className="text-gray-400 hover:text-blue-500"
                                                                            />


                                                                            From : {extractEmail(item?.Email?.sentBy || item?.sentBy, { html: false })}


                                                                        </>
                                                                    )}
                                                                </div>
                                                                {item?.nextStep && (
                                                                    <div
                                                                        className="flex items-center gap-1 border-1"
                                                                        style={{ width: '88px' }}
                                                                    >
                                                                        <div className="h-[20px] flex items-center gap-x-[10px]]">
                                                                            <img src="assets/date.svg" alt="Date" />
                                                                        </div>
                                                                        <div style={{ fontSize: '10px' }}>
                                                                            {item?.nextStep
                                                                                ? moment
                                                                                    .utc(item.nextStep)
                                                                                    .format('dddd, h:mm A')
                                                                                : ''}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                <div>
                                                                    <div className="flex flex-wrap gap-2">
                                                                        {collectUniqueSlaTags(item).map((tag, index) => {
                                                                            const matched = sla_alert_action.find(
                                                                                (action) => action.value === tag,
                                                                            );
                                                                            return matched ? (
                                                                                <div
                                                                                    key={index}
                                                                                    className={` px-2 py-1 rounded-md flex text-[10px]  items-center gap-1 ${matched.color}`}
                                                                                >
                                                                                    <span>
                                                                                        <LiaTagsSolid />
                                                                                    </span>
                                                                                    <span>{matched.label}</span>
                                                                                </div>
                                                                            ) : null;
                                                                        })}
                                                                    </div>
                                                                </div>

                                                                <div style={{ display: 'flex' }}>
                                                                    <div className="flex items-center gap-2 px-[0.4vw] ">
                                                                        {item?.taskType === 'Gmail' ? (
                                                                            <HiMailOpen className="w-4 h-4" />
                                                                        ) : item?.taskType === 'Whatsapp' ? (
                                                                            <img
                                                                                src="assets/whatsapp.svg"
                                                                                alt="whatsapp"
                                                                                className="w-4 h-4"
                                                                            />
                                                                        ) : null}
                                                                        <span
                                                                            className={`truncate max-w-[10vw] ${item?.Email?.messageRead === 'unread' ||
                                                                                item?.subEmail?.messageRead === 'unread'
                                                                                ? 'font-bold'
                                                                                : 'font-normal'
                                                                                }`}
                                                                            title={
                                                                                item?.taskType === 'Whatsapp'
                                                                                    ? item?.title || item?.name
                                                                                    : item?.taskType === 'Gmail'
                                                                                        ? item?.title?.trim()
                                                                                            ? item?.title
                                                                                            : item?.subject
                                                                                        : ''
                                                                            }
                                                                        >
                                                                            {item?.taskType === 'Whatsapp'
                                                                                ? item?.title || item?.name
                                                                                : item?.taskType === 'Gmail'
                                                                                    ? item?.title?.trim()
                                                                                        ? item?.title
                                                                                        : item?.subject
                                                                                    : null}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                {item?.myDayPlan && (
                                                                    <div
                                                                        style={{ width: '88px' }}
                                                                        className={`flex items-center gap-1 border-1 ${item?.subEmail?.messageRead === 'unread' ||
                                                                            item?.Email?.messageRead === 'unread'
                                                                            ? 'font-bold'
                                                                            : 'font-normal'
                                                                            }`}
                                                                    >
                                                                        <div className="h-[20px] flex items-center gap-x-[10px]]">
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="16"
                                                                                height="10"
                                                                                fill="currentColor"
                                                                                className="bi bi-flag"
                                                                                viewBox="0 0 10 16"
                                                                            >
                                                                                <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12 12 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A20 20 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a20 20 0 0 0 1.349-.476l.019-.007.004-.002h.001M14 1.221c-.22.078-.48.167-.766.255-.81.252-1.872.523-2.734.523-.886 0-1.592-.286-2.203-.534l-.008-.003C7.662 1.21 7.139 1 6.5 1c-.669 0-1.606.229-2.415.478A21 21 0 0 0 3 1.845v6.433c.22-.078.48-.167.766-.255C4.576 7.77 5.638 7.5 6.5 7.5c.847 0 1.548.28 2.158.525l.028.01C9.32 8.29 9.86 8.5 10.5 8.5c.668 0 1.606-.229 2.415-.478A21 21 0 0 0 14 7.655V1.222z" />
                                                                            </svg>
                                                                        </div>
                                                                        <div
                                                                            style={{ fontSize: '10px' }}
                                                                            className={
                                                                                item?.subEmail?.messageRead === 'unread' ||
                                                                                    item?.Email?.messageRead === 'unread'
                                                                                    ? 'font-bold'
                                                                                    : 'font-normal'
                                                                            }
                                                                        >
                                                                            {item?.myDayPlan
                                                                                ? moment(item.myDayPlan).format('dddd, h:mm A')
                                                                                : ''}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </h3>
                                                    </>
                                                ) : (
                                                    <>
                                                        <textarea
                                                            ref={textareaRef}
                                                            className="resize-textarea input-static1 outline-text !h-auto overflow-hidden focus:border-none !focus:outline-none placeholder:text-[#000] max-h-40"
                                                            placeholder={editTaskTitle}
                                                            value={editTaskTitle}
                                                            onInput={(e) => {
                                                                e.target.style.height = 'auto';
                                                                e.target.style.height = `${e.target.scrollHeight}px`;
                                                            }}
                                                            onChange={(e) => {
                                                                setEditTaskTitle(e.target.value);
                                                                setTaskTitle(e.target.value);
                                                            }}
                                                            onKeyDown={handleKeyDown}
                                                            onBlur={() => {
                                                                handleEditTitleSave();
                                                            }}
                                                            data-no-popup
                                                            autoFocus
                                                        />
                                                    </>
                                                )}
                                                <div className="date-align">
                                                    <span>
                                                        {(item?.subEmail?.messageRead === 'unread' ||
                                                            item?.Email?.messageRead === 'unread') && (
                                                                <div className="unread-red-dot"></div>
                                                            )}
                                                    </span>
                                                    <span
                                                        className={`text-black text-[12px] ${item?.subEmail?.messageRead === 'unread' ||
                                                            item?.Email?.messageRead === 'unread'
                                                            ? 'font-bold'
                                                            : 'font-normal'
                                                            }`}
                                                    >
                                                        {item.isLabel ? <LabelIcon style={{ fontSize: '16px', marginRight: '8px' }} /> : ''}

                                                        {item?.Email?.createdAtEmail ? moment(item.Email.createdAtEmail).format('MMM DD,h:mm') : item?.createdAt ? moment(item.createdAt).format('MMM DD,h:mm') : ''}
                                                    </span>

                                                    <div className="calendar-dropdown calendar-start">
                                                        <div className="absolute-span flex">
                                                            {moduleName === 'board' ? (
                                                                <>{item?.fetchedAt}</>
                                                            ) : (
                                                                moduleName === 'datePaln' && (
                                                                    <>
                                                                        <div className="text-gray-700 text-[13px]">
                                                                            {item?.currentTime}
                                                                        </div>
                                                                    </>
                                                                )
                                                            )}
                                                            <button
                                                                className={`arrow functionality-open ${isOpen ? 'open' : ''}`}
                                                                onClick={() => {
                                                                    toggleTaskDropdown(item?.id, item);
                                                                }}
                                                                data-no-popup
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="10"
                                                                    height="10"
                                                                    fill="currentColor"
                                                                    className="bi bi-chevron-down down-bottom"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path
                                                                        fillRule="evenodd"
                                                                        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                                                    />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                {assignedUserName && (
                                                    <div className="assigned-user text-black">{assignedUserName}</div>
                                                )}
                                            </div>
                                            {item?.SubTasks && item?.SubTasks.length > 0 && (
                                                <div
                                                    style={{
                                                        marginTop: '10px',
                                                        paddingLeft: '15px',
                                                        borderLeft: '2px solid #ccc',
                                                    }}
                                                >
                                                    {item.SubTasks.map((subTask) => (
                                                        <div>
                                                            <ChildTask
                                                                item={subTask}
                                                                moveChildTask={moveChildTask}

                                                                highlightClass={
                                                                    item?.subEmail?.messageRead === 'unread' ||
                                                                        item?.Email?.messageRead === 'unread'
                                                                        ? 'font-bold'
                                                                        : 'font-normal'
                                                                }
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                            <div className="grid-disp">
                                                <div className="calendar-dropdown master-calendar deadline-align-task">
                                                    {moduleName === 'datePaln' ? (
                                                        <span className="">
                                                            <span
                                                                className={`${showTime ? 'open' : ''} deadline-btn`}
                                                                onClick={inTaskProgress}
                                                            >
                                                                Ideas
                                                            </span>
                                                        </span>
                                                    ) : (
                                                        <span className="calendar-child calendar-datee">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="10"
                                                                height="10"
                                                                fill="currentColor"
                                                                className="bi bi-flag flag-deadline"
                                                                viewBox="0 0 16 16"
                                                            >
                                                                <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12 12 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A20 20 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a20 20 0 0 0 1.349-.476l.019-.007.004-.002h.001M14 1.221c-.22.078-.48.167-.766.255-.81.252-1.872.523-2.734.523-.886 0-1.592-.286-2.203-.534l-.008-.003C7.662 1.21 7.139 1 6.5 1c-.669 0-1.606.229-2.415.478A21 21 0 0 0 3 1.845v6.433c.22-.078.48-.167.766-.255C4.576 7.77 5.638 7.5 6.5 7.5c.847 0 1.548.28 2.158.525l.028.01C9.32 8.29 9.86 8.5 10.5 8.5c.668 0 1.606-.229 2.415-.478A21 21 0 0 0 14 7.655V1.222z" />
                                                            </svg>
                                                            <span
                                                                className={`deadline-btn text-black ${showTime ? 'open' : ''} ${item?.subEmail?.messageRead === 'unread' ||
                                                                    item?.Email?.messageRead === 'unread'
                                                                    ? 'font-bold'
                                                                    : 'font-normal'
                                                                    }`}
                                                                onClick={() => {
                                                                    deadlineDrop(item?.id);
                                                                }}
                                                                data-no-popup
                                                            >
                                                                {item?.deadline
                                                                    ? moment(item?.deadline).format('DD MMMM')
                                                                    : 'Deadline'}
                                                            </span>
                                                        </span>
                                                    )}
                                                </div>
                                                <div
                                                    className={`${userAssigneeName ? 'inline-flex items-center' : 'svg-circle'
                                                        } absolute-span-1`}
                                                >
                                                    {isHovered && (
                                                        <>

                                                            {item.isTaskDependency && (
                                                                <span
                                                                    className="circle-user cursor-pointer mr-2"
                                                                    title="This task has dependencies"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        openDependenciesModal(item);
                                                                    }}
                                                                >
                                                                    <GoGitCompare className="w-4 h-4 text-indigo-600" />
                                                                </span>
                                                            )}
                                                            <span className="circle-user cursor-pointer mr-2" title="Set Dependencies">
                                                                <FaLink
                                                                    className="w-4 h-4 text-gray-600 hover:text-gray-800"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        openDependencyModal(item);
                                                                    }}
                                                                />
                                                            </span>
                                                            <span className="circle-user cursor-pointer mr-1">
                                                                <svg
                                                                    width="22"
                                                                    height="22"
                                                                    viewBox="0 0 24 24"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleArchiveClick(item);
                                                                    }}
                                                                >
                                                                    <path
                                                                        d="M7.75 12.0001L10.58 14.8301L16.25 9.17012"
                                                                        stroke="#7d7d7d"
                                                                        strokeWidth="2.5"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                </svg>
                                                            </span>
                                                        </>
                                                    )}
                                                    <div>
                                                        <span
                                                            className={`circle-user ${userAssigneeName
                                                                ? 'ml-[5px] user-border bg-[#512da8] text-[#fff]'
                                                                : ''
                                                                } `}
                                                            onClick={() => {
                                                                handleToggleSearchBox(item);
                                                            }}
                                                            data-no-popup
                                                        >
                                                            {userAssigneeName ? (
                                                                <div className="circle-user-initial ">
                                                                    {userName && userName.charAt(0).toUpperCase()}
                                                                </div>
                                                            ) : (
                                                                <img
                                                                    src="./assets/person.svg"
                                                                    alt="person"
                                                                    className="bi bi-person"
                                                                />
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div>
                                                {item?.notes && (
                                                    <div className="text-sm text-gray-800 whitespace-pre-wrap break-words max-w-md leading-snug">
                                                        <span
                                                            className="inline-block align-top"
                                                            style={{ fontSize: '12px', minWidth: '70px' }}
                                                        >
                                                            Next Step:
                                                        </span>
                                                        <span
                                                            className="inline-block align-top overflow-hidden"
                                                            style={{
                                                                display: '-webkit-box',
                                                                WebkitLineClamp: 1,
                                                                WebkitBoxOrient: 'vertical',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                fontSize: '12px',
                                                                maxWidth: '300px',
                                                                verticalAlign: 'top',
                                                            }}
                                                            title={item.notes}
                                                        >
                                                            {item.notes}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </>
                                </div>
                                {item.columnId !== 1 && (
                                    <button
                                        onClick={() => moveTaskToColumn(item.id, item.columnId - 1)}
                                        className="button__left btn_desktop button"
                                    >
                                        <FontAwesomeIcon icon={faArrowLeftLong} />
                                    </button>
                                )}
                                {item.columnId !== 4 && (
                                    <button
                                        onClick={() => moveTaskToColumn(item.id, item.columnId + 1)}
                                        className="button__right btn_desktop button"
                                    >
                                        <FontAwesomeIcon icon={faArrowRightLong} />
                                    </button>
                                )}
                                {item.columnId !== 1 && (
                                    <button onClick={() => moveTaskUp(item.id)} className="button__left btn_mobile button">
                                        <FontAwesomeIcon icon={faArrowUpLong} />
                                    </button>
                                )}
                                {item.columnId !== 4 && (
                                    <button onClick={() => moveTaskDown(item.id)} className="button__right btn_mobile button">
                                        <FontAwesomeIcon icon={faArrowDownLong} />
                                    </button>
                                )}
                            </div>
                        </div>

                        <div
                            ref={deadlineDropdownRef}
                            onClick={() => deadlineDrop(item.id)}
                            className={`${openDeadlineTaskId === item.id ? 'block' : 'hidden'}  ${deadlineOpenUpwards ? 'dropdown-up-deadline' : ''
                                }`}
                        >
                            <div
                                className={`dropdown ${openDeadlineTaskId === item.id ? 'open' : ''}
                     ${deadlineOpenUpwards ? 'dropdown-up-deadline' : ''}
                    deadline-day deadend-start deadline-dropdown kanban-dropDown`}
                            >
                                <div className="ulList">
                                    <ul className="ulname-list items-list">
                                        <div className="deadline-text">
                                            <h3 className="deadline-head">Deadline...</h3>
                                            <span className="clear-button clr-position">Clear</span>
                                        </div>
                                        {allDaysData?.map((item) => {
                                            return (
                                                <>
                                                    <li key={item?.id}>
                                                        <div
                                                            id={item}
                                                            className="text-listdrop daysof-week"
                                                            data-no-popup
                                                            onClick={() => {
                                                                switch (item?.deadline) {
                                                                    case 'Today':
                                                                        handleTodayClick();
                                                                        break;
                                                                    case 'Tomorrow':
                                                                        handleTomorrowClick();
                                                                        break;
                                                                    case 'In two days':
                                                                        handleNextTwoDaysClick();
                                                                        break;
                                                                    case 'Next week':
                                                                        handleNextWeekDaysClick();
                                                                        break;
                                                                    case 'Pick a date':
                                                                        if (isCalendarOpen !== true) {
                                                                            setIsCalendarOpen(true);
                                                                        } else {
                                                                            setIsCalendarOpen(false);
                                                                        }
                                                                        break;
                                                                    default:
                                                                        break;
                                                                }
                                                            }}
                                                        >
                                                            {item?.deadline === 'Today' && (
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    fill="currentColor"
                                                                    className="bi bi-brightness-alt-high-fill inlineBlock"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path d="M8 3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 3m8 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5m-13.5.5a.5.5 0 0 0 0-1h-2a.5.5 0 0 0 0 1zm11.157-6.157a.5.5 0 0 1 0 .707l-1.414 1.414a.5.5 0 1 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0m-9.9 2.121a.5.5 0 0 0 .707-.707L3.05 5.343a.5.5 0 1 0-.707.707zM8 7a4 4 0 0 0-4 4 .5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5 4 4 0 0 0-4-4" />
                                                                </svg>
                                                            )}
                                                            {item?.deadline === 'Tomorrow' && (
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    fill="currentColor"
                                                                    className="bi bi-brightness-high-fill inlineBlock"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path
                                                                        d="M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0M8

 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0m0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13m8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5M3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8m10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0m-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0m9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707M4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708"
                                                                    />
                                                                </svg>
                                                            )}
                                                            {item?.deadline === 'In two days' && (
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    fill="currentColor"
                                                                    className="bi bi-clock-history inlineBlock"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z" />
                                                                    <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z" />
                                                                    <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5" />
                                                                </svg>
                                                            )}
                                                            {item?.deadline === 'Next week' && (
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    fill="currentColor"
                                                                    className="bi bi-calendar4-event inlineBlock"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                                                                    <path d="M11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z" />
                                                                </svg>
                                                            )}
                                                            {item?.deadline === 'Pick a date' && (
                                                                <div
                                                                    className="highlight-container"
                                                                    style={{ display: 'inline-block' }}
                                                                >
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="16"
                                                                        height="16"
                                                                        fill="currentColor"
                                                                        className="bi bi-calendar2-minus inlineBlock"
                                                                        viewBox="0 0 16 16"
                                                                    >
                                                                        <path d="M5.5 10.5A.5.5 0 0 1 6 10h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5" />
                                                                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                                                                        <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
                                                                    </svg>
                                                                </div>
                                                            )}
                                                            {item?.deadline === 'Add this item to My Day plan' && (
                                                                <input
                                                                    type="checkbox"
                                                                    checked={checked}
                                                                    onChange={handleChange}
                                                                    className="inlineBlock input-Taskk"
                                                                />
                                                            )}
                                                            <div className="currentDay">
                                                                {item?.deadline &&
                                                                    item?.deadline.charAt(0).toUpperCase() +
                                                                    item?.deadline.slice(1)}
                                                                <div>{item.dayName}</div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className={`ideas ${isProgress ? 'open' : ''} mt-[-268px] ideas-project`}>
                            <div className="max-w-xs p-4 bg-white border rounded shadow-lg">
                                <div className="flex mb-4 justify-between border-b-4">
                                    <input type="text" className="w-full ideastask" />
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-search text-[#696D72]"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                    </svg>
                                </div>
                                <div className="space-y-2">
                                    <div className="border-b pb-2 text-black">
                                        <h2 className="font-semibold border-b-2 text-start">Personal Board</h2>
                                        <ul className="space-y-1 text-start mt-[12px] ml-[10px]">
                                            <li>To do</li>
                                            <li>Working on</li>
                                            <li>Follow up</li>
                                            <li>To Read</li>
                                            <li>Done</li>
                                        </ul>
                                    </div>
                                    <div className="border-b pb-2 text-black">
                                        <h2 className="font-semibold text-start">Project Board</h2>
                                        <ul className="space-y-1 text-start mt-[12px] ml-[10px]">
                                            <li>Ideas</li>
                                            <li>Planned</li>
                                            <li>In progress</li>
                                            <li>Done</li>
                                        </ul>
                                    </div>
                                    <button className="text-[#42B4F4]">Remove from board</button>
                                </div>
                            </div>
                        </div>

                        {showArchiveConfirmation && (
                            <ConfirmationPopup
                                customMessage="Are you sure you want to complete this task?"
                                onCancel={handleCancelArchive}
                                deleteTaskMail={handleConfirmArchive}
                            />
                        )}

                        {showBox === true && (
                            <ConfirmationPopup
                                boardName={'Column'}
                                taskToDeleteId={taskToDelete}
                                onCancel={handleCancelDelete}
                                deleteTaskMail={deleteTask}
                            />
                        )}
                        {taskDetailsModal && (
                            <div className="task-data-popup" ref={popupRef}>
                                <TaskData
                                    isMember={isMember}
                                    parentOrigin={parentOrigin}
                                    taskItem={curretnTaskdata}
                                    gmailMessageID={curretnTaskdata?.gmailMessageId}
                                    updateTaskMail={updateTaskMail}
                                    item={item}
                                    taskDetailsModal={taskDetailsModal}
                                    setTaskDetailModal={setTaskDetailModal}
                                    getTaskMail={getTaskMail}
                                    setCurrentTask={setCurrentTask}
                                    selectedBoardId={selectedBoardId}
                                />
                            </div>
                        )}
                        {isOpen && (
                            <div
                                ref={dropdownRef}
                                onClick={() => {
                                    toggleTaskDropdown(item?.id, item);
                                }}
                                className={`${isOpen ? 'block' : 'hidden'}`}
                            >
                                <div className="layout-backdrop"></div>
                                <div
                                    className={`dropdown dropdown-tactic drop-color ${isOpen ? 'open' : ''} ${openUpwards ? 'dropdown-up' : ''
                                        }`}
                                >
                                    <div className=" grid-ui">
                                        <div className="grid-list-chid">
                                            <div>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="12"
                                                    height="12"
                                                    fill="#7d7d7d"
                                                    className="bi bi-box-arrow-up-right inlineBlock"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                                                    />
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 0 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                                                    />
                                                </svg>
                                            </div>
                                            <div>
                                                <svg
                                                    onClick={() => {
                                                        handleEditTitle(item);
                                                    }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="12"
                                                    height="12"
                                                    fill="#7d7d7d"
                                                    className="bi bi-pencil-fill inlineBlock"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                                                </svg>
                                            </div>

                                            <div>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="12"
                                                    height="12"
                                                    fill="#7d7d7d"
                                                    className="bi bi-pencil inlineBlock"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168z" />
                                                </svg>
                                            </div>
                                        </div>
                                        <div className="ulname-list grid-child-one">
                                            {['View Details', 'Edit title', 'Highlight'].map((label) => (
                                                <div key={label}>
                                                    <a
                                                        id={label}
                                                        className="text-listdrop"
                                                        onClick={(e) => {
                                                            if (label === 'Edit title') {
                                                                handleEditTitleNew(item);
                                                            } else if (label === 'Delete') {
                                                                setShowBox(true);
                                                            } else if (label === 'View Details') {
                                                                handleTaskDetailPopup(item, e, false);
                                                            }
                                                        }}
                                                        data-no-popup
                                                    >
                                                        {label === 'Highlight' && (
                                                            <div
                                                                className="highlight-container"
                                                                style={{
                                                                    display: 'inline-block',
                                                                    position: 'absolute',
                                                                    right: '7px',
                                                                }}
                                                            >
                                                                <span
                                                                    onClick={clearHighlight}
                                                                    className="clear-button clr-position clear-on"
                                                                >
                                                                    Clear
                                                                </span>
                                                            </div>
                                                        )}
                                                        {label.charAt(0).toUpperCase() + label.slice(1)}
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="Grid-Circle">
                                            {CONSTANTS?.color?.map((color, index) => (
                                                <div
                                                    key={index}
                                                    className={`patch ${color.color} ${activePatch === color.color ? 'active' : ''
                                                        }`}
                                                    onClick={() => {
                                                        handleClick(color.value);
                                                        setHoverIndex(color.value1);
                                                        setColorIndexID(indexId);
                                                        handleTaskSelectedColor(color.value);
                                                    }}
                                                ></div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {String(searchBoxTaskId) === String(item?.id) && (
                            <div ref={searchDropdownRef} className="relative z-50">
                                <div
                                    className="fixed inset-0 z-0"
                                    onClick={() => {
                                        setSearchBoxTaskId(null);
                                        setSearchTerm('');
                                    }}
                                ></div>

                                <div
                                    className="absolute bg-white border shadow rounded-xl p-3 w-64"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <label className="block mb-1 text-sm font-medium"></label>

                                    <input
                                        type="text"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        placeholder="Search by name"
                                        className="w-full px-2 py-1 border rounded mb-2"
                                    />

                                    <ul className="max-h-48 overflow-y-auto px-0">
                                        {(searchTerm ? filteredUsers : taskAssign).length === 0 ? (
                                            <li className="text-gray-400 text-sm">No users found</li>
                                        ) : (
                                            (searchTerm ? filteredUsers : taskAssign).map((user) => (
                                                <li
                                                    key={user.id}
                                                    onClick={() => handleUserSelect(user.id)}
                                                    className="flex items-center gap-2 px-0 py-1 hover:bg-gray-100 cursor-pointer"
                                                >
                                                    <div
                                                        className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold text-white"
                                                        style={{ backgroundColor: '#512DA8' }}
                                                    >
                                                        {user.name?.charAt(0)?.toUpperCase()}
                                                    </div>
                                                    <div>
                                                        <div className="font-medium">{user.name}</div>
                                                    </div>
                                                </li>
                                            ))
                                        )}
                                    </ul>
                                </div>
                            </div>
                        )}

                        {isDependencyModalOpen && taskForDependency && (
                            <div
                                className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[1001]"
                                onClick={closeDependencyModal}
                            >
                                <div
                                    className="bg-white p-6 rounded-2xl shadow-xl w-full max-w-2xl transform transition-all"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <div className="flex items-center justify-between mb-4 border-b pb-4">
                                        <h2 className="text-2xl font-bold text-gray-800">
                                            Set Dependencies
                                        </h2>
                                        <button
                                            onClick={closeDependencyModal}
                                            className="text-gray-500 hover:text-gray-800 transition-colors"
                                        >
                                            <svg
                                                className="w-6 h-6"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M6 18L18 6M6 6l12 12"
                                                ></path>
                                            </svg>
                                        </button>
                                    </div>
                                    <p className="mb-4 text-gray-600 truncate">
                                        Task: "{taskForDependency.title || taskForDependency.subject}"
                                    </p>

                                    <div className="mb-4 relative">
                                        <svg
                                            className="w-5 h-5 text-gray-400 absolute inset-y-0 left-0 pl-3"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                            ></path>
                                        </svg>
                                        <input
                                            type="text"
                                            placeholder="Search tasks..."
                                            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-shadow"
                                            value={dependencySearchTerm}
                                            onChange={(e) => setDependencySearchTerm(e.target.value)}
                                        />
                                    </div>

                                    <div className="max-h-72 overflow-y-auto bg-gray-50 p-4 rounded-lg border">
                                        <ul className="space-y-2">
                                            {filteredTasksForDep.length > 0 ? (
                                                filteredTasksForDep.map((t) => (
                                                    <li
                                                        key={t.id}
                                                        className="flex items-center justify-between p-4 bg-white rounded-lg shadow-sm hover:shadow-md cursor-pointer transition-shadow"
                                                        onClick={() => toggleDependency(t.id)}
                                                    >
                                                        <span className="text-gray-800 font-medium">
                                                            {t.title || t.subject}
                                                        </span>
                                                        <div
                                                            className={`w-6 h-6 flex items-center justify-center rounded-md border-2 transition-all ${selectedDependencies.has(t.id)
                                                                ? 'bg-blue-600 border-blue-600'
                                                                : 'bg-white border-gray-300'
                                                                }`}
                                                        >
                                                            {selectedDependencies.has(t.id) && (
                                                                <svg
                                                                    className="w-4 h-4 text-white"
                                                                    fill="none"
                                                                    stroke="currentColor"
                                                                    viewBox="0 0 24 24"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                        strokeWidth="3"
                                                                        d="M5 13l4 4L19 7"
                                                                    ></path>
                                                                </svg>
                                                            )}
                                                        </div>
                                                    </li>
                                                ))
                                            ) : (
                                                <li className="text-center text-gray-500 py-6">
                                                    No tasks found.
                                                </li>
                                            )}
                                        </ul>
                                    </div>

                                    <div className="flex justify-end mt-8 pt-6 border-t">
                                        <button
                                            onClick={closeDependencyModal}
                                            className="px-6 py-3 font-semibold text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={handleSaveDependencies}
                                            className="ml-4 px-6 py-3 font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                        >
                                            Save Dependencies
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {isDependenciesModalOpen && taskWithDependencies && (
                            <div
                                className="fixed inset-0 z-[1001] flex items-center justify-center bg-black bg-opacity-50"
                                onClick={closeDependenciesModal}
                            >
                                <div
                                    className="transform-all w-full max-w-lg transform rounded-2xl bg-white p-6 shadow-xl transition-"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <div className="mb-4 flex items-center justify-between border-b pb-4">
                                        <h2 className="text-2xl font-bold text-gray-800">Task Dependencies</h2>
                                        <button
                                            onClick={closeDependenciesModal}
                                            className="text-gray-500 transition-colors hover:text-gray-800"
                                        >
                                            <svg
                                                className="h-6 w-6"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M6 18L18 6M6 6l12 12"
                                                ></path>
                                            </svg>
                                        </button>
                                    </div>



                                    <div className="max-h-72 overflow-y-auto rounded-lg border bg-gray-50 p-4">
                                        <ul className="space-y-2">
                                            {dependenciesList.length > 0 ? (
                                                dependenciesList.map((t) => (
                                                    <li
                                                        key={t.id}
                                                        className="flex items-center justify-between rounded-lg bg-white p-4 shadow-sm"
                                                    >
                                                        <span className="font-medium text-gray-800">{t.title || t.subject}</span>
                                                        <button
                                                            className="font-semibold text-blue-600 hover:text-blue-800"
                                                            onClick={(e) => {
                                                                handleTaskDetailPopup(t, e, false);
                                                                closeDependenciesModal();
                                                            }}
                                                        >
                                                            View
                                                        </button>
                                                    </li>
                                                ))
                                            ) : (
                                                <li className="py-6 text-center text-gray-500">
                                                    No dependencies found for this task.
                                                </li>
                                            )}
                                        </ul>
                                    </div>

                                    <div className="mt-8 flex justify-end border-t pt-6">
                                        <button
                                            onClick={closeDependenciesModal}
                                            className="rounded-lg bg-gray-100 px-6 py-3 font-semibold text-gray-700 transition-colors hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

            </Draggable>
            <Tooltip id="my-tooltip" placement="top" />

        </>

    );
}

Task.propTypes = {
    item: PropTypes.object.isRequired,
    moveTaskToColumn: PropTypes.func.isRequired,
    moveTaskUp: PropTypes.func.isRequired,
    moveTaskDown: PropTypes.func.isRequired,
    removeTask: PropTypes.func.isRequired,
    indexId: PropTypes.number,
    moduleName: PropTypes.string.isRequired,
    getTaskMail: PropTypes.func.isRequired,
    createTaskMail: PropTypes.func.isRequired,
    columnTitle: PropTypes.func.isRequired,
    setTaskDetailsPopup: PropTypes.func.isRequired,
    taskDetailsPopup: PropTypes.bool.isRequired,
    taskDeadline: PropTypes.object.isRequired,
    userAssigneeName: PropTypes.object.isRequired,
    taskColor: PropTypes.object.isRequired,
    handleUpdateTask: PropTypes.func,
};

export default Task;
